export default __webpack_public_path__ + "static/media/gift.37de8ae9.svg";